import React from 'react'
import Aboutimg from "../assets/DSC_0392.jpg"
import "./about.css"

const About = () => {
  return (
    <div>
<section className='about section' id='about'>
    <h2 className='section__title'  >About Me</h2>
    <br />
   <div className='about__container container grid'>
    <img src="https://techasoft.com/uploads/Developer.jpg" alt="" className='about__img' />
    <div className='about__data'>
        <p className='about__description' id="user-detail-intro">
       <i style={{color:"brown",fontSize:"25px"}}> I'm Sumit Kolipyaka</i>   <br />
        
A competant web developer, skilled in the (MERN) stack with 1200+ hours of 
 practical coding. Knowledge of HTML, CSS, Javascript etc. Highly adaptable and
  avid learner. Aims to leverage knowledge and build worldclass Web applications 
  while facilitating organization in achieving functional goals.
        </p>
    </div>
   </div>
</section>
    </div>
  )
}

export default About